
const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333' }}>
      <h1 style={{ color: '#004d40' }}>Privacy Policy</h1>
      <p><strong>Last updated:</strong> July 10, 2025</p>

      <p>
        Greenwave Innovations Inc. (“we”, “us”, or “our”) values your privacy. This Privacy Policy explains how Greensense Mobile collects, uses, and protects user information.
      </p>

      <h2 style={{ color: '#004d40' }}>1. Information We Collect</h2>
      <p>Greensense Mobile does <strong>not</strong> automatically collect personal data.</p>
      <p>The only data processed by the app is:</p>
      <ul>
        <li>Information <strong>manually entered by the user</strong>, such as notes or text entries.</li>
        <li><strong>Photos or images</strong> taken or uploaded by the user within the app.</li>
      </ul>
      <p>No other data is collected by us or shared with any third parties.</p>

      <h2 style={{ color: '#004d40' }}>2. Third-Party Services</h2>
      <p>Greensense Mobile does <strong>not</strong> integrate any third-party SDKs or services for analytics, advertising, or tracking.</p>
      <p>
        The app communicates with a secure API hosted by us on <strong>Amazon Web Services (AWS)</strong>, which is used solely to support the app's core functionality for registered clients.
      </p>

      <h2 style={{ color: '#004d40' }}>3. User Access</h2>
      <p>
        Access to the app is restricted to authorized users who are existing clients of Greenwave Innovations Inc. There is no public sign-up or account creation functionality within the app.
      </p>

      <h2 style={{ color: '#004d40' }}>4. Data Storage & Security</h2>
      <p>
        All communication between the app and our servers is encrypted using HTTPS. User-entered content (text and images) is securely transmitted and stored within our private infrastructure.
      </p>
      <p>We take reasonable measures to protect user data, including limiting access and using secure cloud storage.</p>

      <h2 style={{ color: '#004d40' }}>5. User Rights</h2>
      <p>
        Since data is only created voluntarily by authorized users, and no additional personal data is collected, users may contact us directly to request deletion of any content they have submitted.
      </p>

      <h2 style={{ color: '#004d40' }}>6. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted to this URL, and we encourage you to review it periodically.
      </p>

      <h2 style={{ color: '#004d40' }}>7. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy or your data, please contact us at:</p>
      <p>
        <strong>Greenwave Innovations Inc.</strong><br />
        Email: <a href="mailto:info@greenwaveinnovations.ca">info@greenwaveinnovations.ca</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;